<template>
  <div style="font-size:14px;">
    <p style="margin-bottom:10px !important;">内容定位</p>
    <div @click="choosePositionDialogShow = true;" class="positionBtn">
      <p style="line-height:45px;color:#1976D2;" class="iconfontFamily">&#xe628;</p>
      <p v-if="thisPositionGeoName === ''" style="line-height:45px;color:#1976D2;" class="ml-3">请选择定位地点</p>
      <p v-if="thisPositionGeoName !== ''" style="line-height:45px;white-space:nowrap; text-overflow:ellipsis; overflow:hidden;" class="ml-3">{{thisPositionGeoName}}</p>
    </div>

    <!--弹窗-->
    <choose-position-dialog v-if="choosePositionDialogShow" :dialogShow="choosePositionDialogShow" @hideChoosePositionDialog="hideChoosePositionDialog" @choosePositionOK="choosePositionOK"
                            :positionGeoJson="positionGeoJson" :positionGeoName="positionGeoName"></choose-position-dialog>

  </div>

</template>

<script>
import ChoosePositionDialog from '/src/components/choose_position/ChoosePositionDialog';
export default {
  name: "CreatePosition",
  components: {
    ChoosePositionDialog
  },
  props:["positionGeoJson","positionGeoName"],
  data(){
    return{
      thisPositionGeoJson:"",
      thisPositionGeoName:"",

      choosePositionDialogShow:false,

    }
  },
  watch:{
    positionGeoJson(){
      this.thisPositionGeoJson = this.positionGeoJson
    },
    positionGeoName(){
      this.thisPositionGeoName = this.positionGeoName
    }
  },
  methods:{
    choosePositionOK(param){
      this.thisPositionGeoName = param.city + '·' + param.name;
      this.thisPositionGeoJson = JSON.stringify({
        "type": "Point",
        "coordinates": [param.lng, param.lat]
      })
      this.$emit("choosePositionOK",param);
    },
    //隐藏选择定位地点弹窗
    hideChoosePositionDialog(){
      this.choosePositionDialogShow = false;
    }
  },
  mounted(){
    this.thisPositionGeoJson = this.positionGeoJson
    this.thisPositionGeoName = this.positionGeoName
  }
}
</script>

<style scoped>
.positionBtn{
  width:266px;
  height:45px;
  border:1px solid #e5e5e5;
  border-radius:3px;
  padding:0 15px;
  display:flex;
  cursor:pointer;
}
.positionBtn:hover{
  border-color:#808080;
}

</style>